<template>
  <div>
    <div class="y-form-item inline-title" v-if="component.controlName === 'inline_title'">
      <label
        class="y-form-label"
        @click.stop="showHighlight(component.highlight_class)"
      >{{ component.displayName }}</label>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item', errors.first(component.key) ? 'error-input' : '']"
      v-if="component.controlName === 'textField'"
    >
      <label
        class="y-form-label"
        @click.stop="showHighlight(component.highlight_class)"
      >{{ component.displayName }}</label>
      <el-input
        v-model="component.defaultValue"
        :name="component.displayName"
        data-vv-validate-on="change"
        :data-vv-as="component.displayName"
        :data-vv-name="component.key"
        v-validate="component.validationRule"
        :key="component.key"
        :autoid="component.autoid"
        @blur="(value) => { this.trimValues(value, component) }"
      ></el-input>
      <span class="errorField" v-show="errors.first(component.key)">
        <i class="el-icon-warning"></i>
        {{ errors.first(component.key) }}
      </span>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item', component.ref_id, errors.first(component.key) ? 'error-input' : '']"
      v-else-if="component.controlName === 'inline_textField'"
    >
      <el-row
        class="inline-text-field-ctr"
        @click.native.stop="switchPreviewPage(component.previewPageName)"
      >
        <el-col :span="component.displayName == '' ? 0 : 18">
          <label
            class="y-form-label"
            @click.stop="showHighlight(component.highlight_class), switchPreviewPage(component.previewPageName)"
          >{{ component.displayName }}</label>
        </el-col>
        <el-col :span="component.displayName == '' ? 24 : 6" style="text-align:right">
          <span v-show="edit || component.defaultValue == ''">
            <el-input
              v-model="component.defaultValue"
              :name="component.displayName"
              data-vv-validate-on="change"
              :data-vv-as="component.displayName"
              :data-vv-name="component.key"
              v-validate="component.validationRule"
              :key="component.key"
              class="inline-edit-text-field"
              @blur.native.capture="edit = false"
              @keyup.enter.native="edit = false"
              :autoid="component.autoid"
            ></el-input>
          </span>
          <span
            class="inline-edit-text"
            :autoid="component.autoid"
            v-show="!edit"
            @click="edit = true"
          >
            {{
            component.defaultValue
            }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span class="errorField" v-show="errors.first(component.key)">
            <i class="el-icon-warning"></i>
            {{ errors.first(component.key) }}
          </span>
        </el-col>
      </el-row>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item', component.ref_id, errors.first(component.key) ? 'error-input' : '']"
      v-else-if="component.controlName === 'mulitline_textField'"
    >
      <label
        class="y-form-label"
        @click.stop="showHighlight(component.highlight_class)"
      >{{ component.displayName }}</label>
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 10 }"
        v-model="component.defaultValue"
        :name="component.displayName"
        data-vv-validate-on="change"
        :data-vv-as="component.displayName"
        :data-vv-name="component.key"
        v-validate="component.validationRule"
        :key="component.key"
        :autoid="component.autoid"
        @blur="(value) => { this.trimValues(value, component) }"
      ></el-input>
      <span class="errorField" v-show="errors.first(component.key)">
        <i class="el-icon-warning"></i>
        {{ errors.first(component.key) }}
      </span>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item']"
      v-if="component.controlName === 'inline_select'"
    >
      <el-row class="inline-text-field-ctr">
        <el-col :span="12">
          <label
            class="y-form-label"
            @click.stop="showHighlight(component.highlight_class)"
          >{{ component.displayName }}</label>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-select
            v-model="component.defaultValue"
            :size="component.size"
            :autoid="component.autoid"
            v-bind:style="{ width: component.width }"
          >
            <el-option
              v-for="item in component.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item']"
      v-if="component.controlName === 'select'"
    >
      <el-select
        v-model="component.defaultValue"
        :size="component.size"
        v-bind:style="{ width: component.width }"
        :ref="component.ref_id"
        :id="component.ref_id"
        :autoid="component.autoid"
        @change="component.actionMethod ? handle_function_call(component.actionMethod, component): ''"
      >
        <el-option
          v-for="item in component.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item select-tags']"
      v-if="component.controlName === 'remote_select'"
    >

        
      <el-autocomplete
        v-model="siteSearch"
        :fetch-suggestions="searchSites"
        placeholder="Search Popular sites"
        @select="((e)=>{handleSelect(e, component.defaultValue )})"
        value-key="name"
        :trigger-on-focus="false"
      ></el-autocomplete>

      <div v-bind:class="[component.defaultValue != '' || component.defaultValue.length != 0 ? 'y-sites-tags-cnr' : 'hide']">
          <el-tag
                class='y-tag'
                v-for="tag in (() => constructSiteModel(component))()"
                :key="tag.id"
                type="info"
                @close="(()=>{deleteSites(tag.id, component.defaultValue)})"
                closable
                >
                {{tag.name}}
            </el-tag>
        </div>
      
    </div>

    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item']"
      v-else-if="component.controlName === 'inline_colorPicker'"
    >
      <el-row>
        <el-col :span="20">
          <label
            class="y-form-label"
            @click.native.stop="showHighlight(component.highlight_class), switchPreviewPage(component.previewPageName)"
          >{{ component.displayName }}</label>
        </el-col>
        <el-col :span="4" style="text-align:right">
          <el-color-picker
            v-model="component.defaultValue"
            @active-change="(value) => { this.changeColor(value, component) }"
            @click.native.stop="updateColorPicker"
            :autoid="component.autoid"
          ></el-color-picker>
        </el-col>
      </el-row>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item', component.ref_id]"
      v-else-if="component.controlName === 'toggle'"
    >
      <el-row>
        <el-col :span="20">
          <label
            class="y-form-label"
            @click.stop="showHighlight(component.highlight_class)"
          >{{ component.displayName }}</label>
        </el-col>
        <el-col :span="4" style="text-align:right">
          <el-switch
            v-model="component.defaultValue"
            :autoid="component.autoid"
            :id="component.ref_id"
            @change="component.actionMethod? handle_function_call(component.actionMethod, component) : ''"
          ></el-switch>
        </el-col>
      </el-row>
    </div>
    <div
      v-else-if="component.controlName === 'toggle_has_child'"
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item']"
    >
      <el-row class="y-inner-form-ctr">
        <el-col :span="20">
          <label
            class="y-form-label"
            @click.stop="showHighlight(component.highlight_class)"
          >{{ component.displayName }}</label>
        </el-col>
        <el-col :span="4" style="text-align:right">
          <el-switch v-model="component.defaultValue" :autoid="component.autoid"></el-switch>
        </el-col>
      </el-row>
      <div v-show="component.defaultValue">
        <div v-for="(component, index) in component.dependentForm" :key="index">
          <div v-if="component.innerAccordion && component.innerAccordion.length > 0">
            <el-collapse accordion class="y-inner-accordion-ctr">
              <div v-for="(item, index) in component.innerAccordion" :key="index">
                <el-collapse-item
                  :autoid="item.autoid"
                  :label="item.title"
                  :title="item.title"
                  :name="item.title"
                >
                  <div class="y-form-row" v-for="(component, index) in item.form" :key="index">
                    <cust-conditional-render :dataProps="component" />
                  </div>
                </el-collapse-item>
              </div>
            </el-collapse>
          </div>
          <div v-else>
            <cust-conditional-render :dataProps="component" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-bind:class="[component.indent ? 'form-indent' : '', 'y-form-item']"
      v-else-if="component.controlName === 'template-upload'"
    >
      <div v-if="component.type === 'primaryfont'">
        <y-primaryfont-upload
          :deleteFileName="deleteUploadedFile"
          :removeHandler="deleteFont"
          :beforeUploadHandler="onUploadFile"
          :fileUploadProps="component"
          :uploadHandler="submitUploadFont"
        ></y-primaryfont-upload>
      </div>
      <div v-else-if="component.type === 'secondaryfont'">
        <y-secondaryfont-upload :fileUploadProps="component" :uploadHandler="submitUploadFont"></y-secondaryfont-upload>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import { custToolHelper } from '../mixins/custToolHelper'
import { helpers } from '../mixins/helpers'
import serviceRegistery from '../mixins/serviceRegistery'
import yFileUploadPopup from '../components/yFileUploadPopup'

export default {
  name: 'cust-conditional-render',
  inject: ['$validator'],
  mixins: [custToolHelper, serviceRegistery, helpers],
  data() {
    return {
      fontUploadDialog: true,
      edit: false,
      fileList: [{ name: 'test', url: 'tes' }],
      fontname: '',
      queryString: '',
      sites: [],
      fontList: [],
      fontFamilyName: '',
      fontFileUploadErrorMsg: '',
      optDisabled: true,
      siteSearch: ''
    }
  },
  props: {
    dataProps: Object
  },
  created() {},
  
  updated() {
    this.$nextTick(function() {
      this.toggleTncFields()
      this.toggleSplashPage()
    })
  },
  components: {
    'y-primaryfont-upload': yFileUploadPopup,
    'y-secondaryfont-upload': yFileUploadPopup,
    'y-header-upload': yFileUploadPopup,
    'y-footer-upload': yFileUploadPopup
  },
  computed: {
    component() {
      return this.dataProps
    },
    displayName() {
      return this.dataProps.displayName
    },
    showFontUploadDialog() {
      return this.$store.state.custAppStore.showFontUploadDialog
    },
    fontData() {
      return this.$store.state.cssStore.fontOptions
    },
    popularSites() {
      return this.$store.state.paramStore.popularSites
    }
  },
  methods: {
    deleteSites(id, selectedValues) {
        var index = _.findIndex(selectedValues, {id: id})
        selectedValues.splice(index, 1)
    },
    constructSiteModel(siteDefaultValue){
        var siteModel = siteDefaultValue.defaultValue
        if( !_.isEmpty(siteModel) && siteModel[0] && _.isUndefined(siteModel[0].name)){
            let newSiteModel = []
            for(var i = 0; i<this.popularSites.length; i++){
                if(siteModel.indexOf(this.popularSites[i].id) != -1 ){
                    newSiteModel.push({id: this.popularSites[i].id, name: this.popularSites[i].name})
                } 
            }
            siteDefaultValue.defaultValue = newSiteModel
        } else {
            siteDefaultValue.defaultValue = siteModel || []
        }

        return siteDefaultValue.defaultValue
    },
    handleSelect(item, selectedValues) {
        var itemfound = false
        if(selectedValues) {
         itemfound = selectedValues.some((el) => {
                return el.id === item.id
            })
        }
        if (!itemfound) selectedValues.push({ id: item.id, name: item.name })
        this.siteSearch = ''
    },
    toggleTncFields() {
      if (
        this.component.ref_id === 'tncLink' ||
        this.component.ref_id === 'tncInput'
      ) {
        if ($('#tncLinkOrInline').length) {
          if ($('#tncLinkOrInline').val() === 'Link') {
            $('.tncLink')
              .removeClass('d-none')
              .removeAttr('style')
            $('.tncInput').addClass('d-none')
          } else {
            $('.tncLink').addClass('d-none')
            $('.tncInput')
              .removeClass('d-none')
              .removeAttr('style')
          }
        }
      }
    },
    toggleSplashPage() {
      if (this.component.ref_id === 'enableSplash') {
        if ($('#showHideSplashPage').is(':checked') === true) {
          $('.enableSplash')
            .removeClass('d-none')
            .removeAttr('style')
        } else {
          $('.enableSplash').addClass('d-none')
        }
      }
    },
    updateColorPicker(e) {
      var self = this
      let methodName = 'revertDefaultValue'
      $(
        '.el-color-picker__panel .el-color-dropdown__btns .el-color-dropdown__link-btn'
      ).replaceWith(
        '<a href="javascript:void(0);" class="revert-link" >Revert to default</a>'
      )
      $('.revert-link').off('click')
      $('.revert-link').on('click', function(event) {
        self.revertDefaultValue()
      })

      this.switchPreviewPage(self.component.previewPageName)
    },
    revertDefaultValue() {
      if (
        this.dataProps &&
        this.dataProps.defaultValue &&
        this.dataProps.baseValue
      ) {
        this.dataProps.defaultValue = this.dataProps.baseValue
      }
    },
    disableEnableDependKeys(component) {
      if (component && component.dependend_ref_id) {
        let defaultValue = component.defaultValue
        let depRefIds = component.dependend_ref_id
        let showKeysOn = component.showDependendKeysOn
        if (depRefIds) {
          $('.' + depRefIds)
            .find('.el-switch input')
            .click()
        }
      }
    },
    showHideDependKeys(component) {
      if (
        component &&
        component.dependend_ref_ids &&
        component.showDependendKeysOn
      ) {
        let defaultValue = component.defaultValue
        let depRefIds = component.dependend_ref_ids
        let showKeysOn = component.showDependendKeysOn
        if (depRefIds.toString() === 'enableSplash') {
          if (defaultValue === false) {
            $('.enableSplash').addClass('d-none')
          } else {
            $('.enableSplash')
              .removeClass('d-none')
              .removeAttr('style')
          }
        } else if (depRefIds) {
          if (defaultValue === 'link') {
            $('.tncLink')
              .removeClass('d-none')
              .removeAttr('style')
            $('.tncInput').addClass('d-none')
          } else {
            $('.tncLink').addClass('d-none')
            $('.tncInput')
              .removeClass('d-none')
              .removeAttr('style')
          }
        }
      }
    },
    openUploadFontDialog() {
      this.$store.state.custAppStore.showFontUploadDialog = true
    },
    closeUploadFontDialog() {
      this.fontFamilyName = ''
      this.$refs.uploadFont.clearFiles()
      this.fontFileUploadErrorMsg = ''
      this.$store.state.custAppStore.showFontUploadDialog = false
    },
    changeColor(value, component) {
      component.defaultValue = value
    },
    searchSites: _.debounce(function(query, cb) {
      let self = this
      if (query !== '') {
        serviceRegistery
          .makeCall({
            data: { name: query },
            url: self.$hostname + 'services/brand/sites',
            method: 'POST'
          })
          .then(response => {
            console.log(response)
            if (response) {
              self.sites = response.data.provider

              if(self.sites) {
                  cb(self.sites)
                  $('.el-autocomplete-suggestion__list').removeClass('no-results').find('li.no-match').remove()
              } else {
                  cb([''])
                  $('.el-autocomplete-suggestion__list').addClass('no-results')
                  if($('.no-match').length <= 0) {
                    $('.el-autocomplete-suggestion__list.no-results').append('<li class="no-match">No matching found</li>')
                  }
              }
            }
          })
          .catch(error => {
            self.showToastMessage(
              'Sorry, a technical error has occurred! Please try again later.'
            )
          })
      }
    }, 500),

    trimValues(event, component) {
      if (component.isTrim) {
        component.defaultValue = event.target.value.trim();
      }
    },
    deleteFont(scope, files, componentArg) {
      let component = componentArg
      component.popupProps.isInfo = true
      component.popupProps.infoMessage = ''
      component.popupProps.errorMessage = ''
      component.popupProps.isValid = true
    },
    deleteUploadedFile(scope, fontId, componentArg) {
      let component = componentArg
      var self = this

      let reqObj = {
        id: fontId,
        cobrand: this.$store.state.appStore.selectedSubbrandInfo._id,
        type: 'FONT'
      }

      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/resource/delete',
          method: 'POST',
          data: reqObj
        })
        .then((response) => {

          let fontObj = {}
          self.saveBrandFontData(fontObj)

          self.showToastMessage(
            'Font deleted successfully.'
          )
        }).catch((error)=>{
          self.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    onUploadFile(scope, files, componentArg) {
      let fileList = files
      let component = componentArg
      if (/\.(woff2)$/i.test(fileList[0].name) !== false) {
        component.popupProps.isInfo = false
        component.popupProps.infoMessage =
          '.woff2 font type is not supported on any version of IE browser'
      } else {
        component.popupProps.isInfo = true
        component.popupProps.infoMessage = ''
      }
    },
    submitUploadFont(scope, files, componentArg) {
      let fileList = files
      var self = this
      let ext
      let component = componentArg
      let fontOptions = this.$store.state.cssStore.fontOptions

      if (fileList.length <= 0) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage = 'Please select the file'
      } else if (/\.(woff|woff2)$/i.test(fileList[0].name) === false) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage =
          'Please select the correct font file(.woff or .woff2)'
      } else {
        this.$validator.validateAll(scope).then(result => {
          component.popupProps.errorMessage = ''
          component.popupProps.isValid = true

          if (!fileList.length) return

          const formData = new FormData()

          // Logic to update the font on the same resource ID
          // if (fontOptions && fontOptions.length > 0) {
          //   fontOptions.filter(function(font) {
          //     if (font.fontType === component.type) {
          //       formData.append('id', font.id)
          //       return true
          //     }
          //   })
          // }

          // append the files to FormData
          Array.from(Array(fileList.length).keys()).map(x => {
            fileList[x].name = component.prefix + '-' + fileList[x].name
            formData.append('resource', fileList[x].raw, fileList[x].name)
            ext = fileList[x].name.split('.').pop()
            formData.append('format', ext)
          })

          formData.append(
            'cobrand',
            this.$store.state.appStore.selectedSubbrandInfo._id
          )
          formData.append('type', 'FONT')
          formData.append('environment', 'PRODUCTION')

          serviceRegistery
            .makeCall({
              method: 'PUT',
              url: this.$hostname + 'services/resource/upload',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(response => {
              let fontObj = {}

              fontObj['id'] = response.data._id
              fontObj['fileName'] = response.data.fileName
              fontObj['fontType'] = component.type
              fontObj['fontFamily'] = component.fontFamilyName
              fontObj['fontStyle'] = 'normal'
              fontObj['fontWeight'] = '400'
              fontObj['format'] = ext

              self.saveBrandFontData(fontObj)
              component.popupProps.isPopupOpen = true
              component.popupProps.isPopupOpen = false
              if (self.$refs.uploadFont) self.$refs.uploadFont.clearFiles()
              self.showToastMessage(
                'Font uploaded successfully.'
              )
            })
            .catch(error => {
              console.log('submit file')
              component.popupProps.isPopupOpen = true
              component.popupProps.isPopupOpen = false
              if (self.$refs.uploadFont) self.$refs.uploadFont.clearFiles()
              self.showToastMessage(
                'Sorry, a technical error has occurred! Please try again later.'
              )
            })
        })
      }
    },
    saveBrandFontData(fontObj) {
      console.log('Save font details to the brand')
      var self = this
      let fontOptions = this.$store.state.cssStore.fontOptions
      let fontArr

      if (fontOptions && fontOptions.length > 0 && !_.isEmpty(fontObj)) {
        fontArr = fontOptions.filter(function(font) {
          if (font.fontType === fontObj.fontType) {
            font.fileName = fontObj.fileName
            return true
          }
        })
      }

      if (!fontArr || fontArr.length === 0) {
        if (_.isEmpty(fontObj)) {
          fontOptions.pop(fontObj)
        } else {
          fontOptions.push(fontObj)
        }
      }

      var brandJson = {}
      brandJson['font.default'] = fontOptions

      this.$store.commit("updateFont", fontOptions )

      let reqObj = {
        id: this.$store.state.appStore.selectedSubbrandInfo._id,
        jsonData: JSON.stringify({ brand: brandJson })
      }

      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/update',
          method: 'POST',
          data: reqObj
        })
        .then((response) => {
          if ( response.data && response.data.brand ) {
            self.$store.state.custAppStore.cobrandDraftData = response.data.brand
          }
          console.log('Cobrand branding data Saved')
        })
    }
  }
}
</script>

<style lang="scss">
.file-uploader-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #dedede;
  }
  .el-dialog__body {
    padding-top: 16px;
    .file-details-row {
      .ff-name-cnr {
        .el-form-item__label {
          line-height: 24px;
          &::before {
            display: none;
          }
        }
        .el-input {
          input {
            height: 40px;
            line-height: 40px;
          }
        }
      }
      .ff-name-cnr.el-form-item {
        margin-bottom: 12px;
      }
      .ff-add-action-cnr {
        margin-bottom: 12px;
        ul.el-upload-list {
          display: inline-block;
          vertical-align: top;
        }
      }
    }
    .ff-upload-btn-cnr {
      padding-bottom: 8px;
      border-bottom: 1px solid #dedede;
      button {
        padding: 9px;
      }
    }
    .ff-uploaded-fonts {
      th,
      td {
        padding: 0;
      }
      thead tr {
        th:nth-child(3) {
          text-align: right;
        }
      }
      tbody tr {
        td {
          padding: 8px 0;
        }
        td:last-child {
          text-align: right;
        }
      }
    }
  }
}
</style>
